import QuotePricePackageWrapper from '../quote-price-package-wrapper';
import css from './index.module.scss';
import { useFormContext } from 'react-hook-form';

interface IQuoteFreightPort {
  totalLocalFreight: string;
  totalLocalFreightCurrency: string;
  totalPortAndClearanceExpenses: string;
  totalPortAndClearanceExpensesCurrency: string;
  selectedCurrency: any[];
  fobPriceManualOverride?: string;
}

const QuoteFreightPort = (props: IQuoteFreightPort) => {
  const {
    totalLocalFreight,
    totalLocalFreightCurrency,
    totalPortAndClearanceExpenses,
    totalPortAndClearanceExpensesCurrency,
    selectedCurrency,
    fobPriceManualOverride
  } = props;

  const { setValue, control } = useFormContext();

  return (
    <div className={css.rowWrapper}>
      <QuotePricePackageWrapper
        label="Total Local Transportation & Freight"
        currencyPlaceholder="Currency"
        inputPlaceholder="Enter Price"
        input={totalLocalFreight}
        currency={totalLocalFreightCurrency}
        control={control}
        currencyOptions={selectedCurrency}
        inputOnChange={() => {
          fobPriceManualOverride && setValue(fobPriceManualOverride, false, { shouldDirty: false });
        }}
      />

      <QuotePricePackageWrapper
        label="Total Port and Clearance Expenses"
        currencyPlaceholder="Currency"
        inputPlaceholder="Enter Price"
        input={totalPortAndClearanceExpenses}
        currency={totalPortAndClearanceExpensesCurrency}
        control={control}
        currencyOptions={selectedCurrency}
        inputOnChange={() => {
          fobPriceManualOverride && setValue(fobPriceManualOverride, false, { shouldDirty: false });
        }}
      />
    </div>
  );
};

export default QuoteFreightPort;
